import { defineComponent as _defineComponent } from 'vue';
import Button from 'primevue/button';
import { computed, ref } from '@vue/runtime-core';
import Menu from 'primevue/menu';
import { useRoute } from '../Plugins/ziggy';
import { Inertia } from '@inertiajs/inertia';
import { usePageProps } from '../Plugins/page-props';
import Sidebar from 'primevue/sidebar';
import { useAxios } from '../Plugins/axios';
import { useSpinner } from '../Plugins/spinner';
export default /*#__PURE__*/ _defineComponent({
    __name: 'UserMenu',
    setup(__props, { expose }) {
        expose();
        const route = useRoute();
        const user = usePageProps();
        const axios = useAxios();
        const spinner = useSpinner();
        const companies = user.user().companies;
        const menu = ref();
        const selectCompanyPanelVisible = ref(false);
        const firstnameInitial = computed(() => user.user().firstname.charAt(0));
        let menuItems = ref([
            {
                label: 'Il tuo profilo',
                icon: 'pi pi-user',
            },
            {
                label: 'Modifica Password',
                icon: 'pi pi-key',
            },
            {
                label: 'Logout',
                icon: 'pi pi-sign-out',
                command: () => Inertia.post(route('logout')),
            },
        ]);
        if (companies.length > 1) {
            menuItems.value.splice(2, 0, {
                label: 'Seleziona Azienda',
                icon: 'pi pi-arrow-right-arrow-left',
                command: () => (selectCompanyPanelVisible.value = true),
            });
        }
        const selectCompany = (company) => {
            axios.post(route('select-company', { id: company.id })).then(() => {
                selectCompanyPanelVisible.value = false;
                spinner.show();
                Inertia.visit('/', {
                    onSuccess: () => {
                        spinner.hide();
                    },
                });
            });
        };
        const __returned__ = { route, user, axios, spinner, companies, menu, selectCompanyPanelVisible, firstnameInitial, get menuItems() { return menuItems; }, set menuItems(v) { menuItems = v; }, selectCompany, get Button() { return Button; }, get Menu() { return Menu; }, get Sidebar() { return Sidebar; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
